import { Lightbulb, Users2, Goal, PieChart } from "lucide-react";
import { Card, CardContent } from "../ui/card";

const highlights = [
  {
    title: "Returners hired",
    value: "3,200",
    trend: "+18% YoY",
    icon: Users2,
    description: "Professionals returning after a career break placed into supportive teams.",
  },
  {
    title: "AI interview coaching",
    value: "92%",
    trend: "Confidence uplift",
    icon: Lightbulb,
    description: "Candidates completing AI rehearsal report higher interview confidence.",
  },
  {
    title: "Skills verified",
    value: "12,480",
    trend: "Skill badges issued",
    icon: Goal,
    description: "Pre-interview skill tests completed across engineering, care, and digital roles.",
  },
  {
    title: "Employer NPS",
    value: "+64",
    trend: "Top quartile",
    icon: PieChart,
    description: "Hiring managers score Lighthouse above legacy job boards for match quality.",
  },
];

export function InsightHighlights() {
  return (
    <div className="grid gap-4 sm:grid-cols-2 xl:grid-cols-4">
      {highlights.map(({ icon: Icon, title, value, trend, description }) => (
        <Card
          key={title}
          className="border-white/10 bg-white/[0.03] transition hover:border-[#d2ac47]/30 hover:bg-white/[0.06]"
        >
          <CardContent className="space-y-4 p-6">
            <div className="flex items-center gap-3">
              <span className="flex h-10 w-10 items-center justify-center rounded-xl bg-[#ba9036]/20 text-[#f7ef8a]">
                <Icon className="h-5 w-5" aria-hidden />
              </span>
              <div>
                <p className="text-sm font-medium text-gray-300">{title}</p>
                <p className="text-xs text-[#f7ef8a]/90">{trend}</p>
              </div>
            </div>
            <p className="text-3xl font-semibold text-white">{value}</p>
            <p className="text-sm text-gray-400/90">{description}</p>
          </CardContent>
        </Card>
      ))}
    </div>
  );
}
